module.exports = __webpack_public_path__ + "img/abnormal-no-data.eb47533c.png";